import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Sale01 from '../components/sale/Sale01';
import { landingApi } from '../api/landing-api';

const typeBadge = {
  MENTORING: { label: 'Mentoring', color: '#0C8F86', icon: '📩' },
  WEBINAR: { label: 'Webinar', color: '#58bd7d', icon: '💻' },
  WORKSHOP: { label: 'Workshop', color: '#d33535', icon: '🔧' },
  NETWORKING: { label: 'Networking', color: '#f59e0b', icon: '🤝' },
  AKADEMI: { label: 'Akademi', color: '#8b5cf6', icon: '📚' },
};

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

const defaultThumbnails = [
  'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80',
  'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&q=80',
  'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=600&q=80',
  'https://images.unsplash.com/photo-1559223607-2ee0b98a305b?w=600&q=80',
];

function formatDate(dateStr) {
  const d = new Date(dateStr);
  const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
  return {
    date: d.getDate(),
    day: days[d.getDay()],
    month: d.toLocaleString('id', { month: 'short' }),
    year: d.getFullYear(),
    time: d.toLocaleString('id', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jakarta' }),
  };
}

function Event() {
  const [events, setEvents] = useState([]);
  const [activeFilter, setActiveFilter] = useState('ALL');
  const FE_WEB_URL = 'https://app.tradiora.id';

  useEffect(() => {
    landingApi.getEvents().then((res) => {
      if (res?.length) setEvents(res);
    }).catch(() => {});
  }, []);

  const types = ['ALL', ...new Set(events.map(e => e.type))];
  const filtered = activeFilter === 'ALL' ? events : events.filter(e => e.type === activeFilter);

  return (
    <div>
      {/* Hero — always dark */}
      <section style={{
        padding: '120px 0 80px',
        background: 'linear-gradient(135deg, #0a1628 0%, #0d1f3c 30%, #1a0a2e 70%, #0a1628 100%)',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: '-20%', right: '-10%', width: 500, height: 500,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(12,143,134,0.12) 0%, transparent 70%)',
          pointerEvents: 'none', animation: 'pulse 8s ease-in-out infinite',
        }} />
        <div style={{
          position: 'absolute', bottom: '-20%', left: '-8%', width: 400, height: 400,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(139,92,246,0.1) 0%, transparent 70%)',
          pointerEvents: 'none', animation: 'pulse 10s ease-in-out infinite reverse',
        }} />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              background: 'rgba(12,143,134,0.15)', borderRadius: 20,
              padding: '6px 16px', marginBottom: 16,
            }}>
              <span style={{ color: 'var(--primary)', fontSize: 10 }}>✦</span>
              <span style={{ color: 'var(--primary)', fontSize: 13, fontWeight: 600 }}>Event & Mentoring</span>
            </div>
            <h1 style={{
              fontSize: 48, fontWeight: 800, color: '#fff', lineHeight: 1.15, marginBottom: 16,
              letterSpacing: '-1px',
            }}>
              Jadwal{' '}
              <span style={{
                background: 'linear-gradient(135deg, var(--primary), #8b5cf6)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              }}>Event & Mentoring</span>
            </h1>
            <p style={{ fontSize: 18, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, maxWidth: 520, margin: '0 auto' }}>
              Ikuti program mentoring, webinar, dan workshop yang diadakan secara rutin oleh Tradiora
            </p>
          </div>
        </div>
      </section>

      {/* Content — theme-aware */}
      <section style={{ padding: '80px 0', background: 'var(--bg)', position: 'relative' }}>
        <div className="container">

          {/* Filter */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 48 }}>
            {types.map((type) => {
              const badge = typeBadge[type];
              const isActive = activeFilter === type;
              const accentColor = badge?.color || '#0C8F86';
              return (
                <button
                  key={type}
                  onClick={() => setActiveFilter(type)}
                  style={{
                    padding: '10px 22px', borderRadius: 60, cursor: 'pointer',
                    fontSize: 13, fontWeight: 700, fontFamily: 'inherit',
                    border: isActive
                      ? `1.5px solid ${accentColor}`
                      : '1.5px solid var(--line)',
                    background: isActive
                      ? accentColor
                      : 'var(--surface)',
                    color: isActive ? '#ffffff' : 'var(--onsurface)',
                    transition: 'all 0.3s ease',
                    textTransform: 'capitalize',
                    appearance: 'none',
                    outline: 'none',
                  }}
                  onMouseEnter={e => {
                    if (!isActive) {
                      e.currentTarget.style.background = 'rgba(12,143,134,0.1)';
                      e.currentTarget.style.borderColor = '#0C8F86';
                    }
                  }}
                  onMouseLeave={e => {
                    if (!isActive) {
                      e.currentTarget.style.background = 'var(--surface)';
                      e.currentTarget.style.borderColor = 'var(--line)';
                    }
                  }}
                >
                  {type !== 'ALL' && badge && <span style={{ marginRight: 6 }}>{badge.icon}</span>}
                  {type === 'ALL' ? 'Semua Event' : badge?.label || type.toLowerCase()}
                </button>
              );
            })}
          </div>

          {/* Event cards */}
          <div className="row">
            {filtered.map((event, index) => {
              const fd = formatDate(event.startTime);
              const badge = typeBadge[event.type] || { label: event.type, color: 'var(--primary)', icon: '📅' };
              const thumb = event.thumbnail
                ? (event.thumbnail.startsWith('http') ? event.thumbnail : `${API_BASE}/public/uploads${event.thumbnail}`)
                : defaultThumbnails[index % defaultThumbnails.length];
              const regCount = event._count?.registrations || 0;
              const maxReg = event.maxParticipants;
              const regPct = maxReg ? Math.min(100, Math.round((regCount / maxReg) * 100)) : 0;

              return (
                <div className="col-xl-4 col-md-6" key={event.id || index} style={{ marginBottom: 24 }} data-aos="fade-up" data-aos-delay={(index % 3) * 80}>
                  <div style={{
                    background: 'var(--surface)',
                    borderRadius: 20, overflow: 'hidden', height: '100%',
                    border: '1px solid var(--line)',
                    display: 'flex', flexDirection: 'column',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                  }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.borderColor = `${badge.color}50`;
                      e.currentTarget.style.boxShadow = `0 24px 60px ${badge.color}15`;
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = '';
                      e.currentTarget.style.borderColor = 'var(--line)';
                      e.currentTarget.style.boxShadow = '';
                    }}
                  >
                    {/* Thumbnail */}
                    <div style={{ position: 'relative', overflow: 'hidden', aspectRatio: '16/9' }}>
                      <img
                        src={thumb}
                        alt={event.title}
                        style={{
                          width: '100%', height: '100%', objectFit: 'cover',
                          transition: 'transform 0.6s ease',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.06)'; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
                        onError={e => {
                          e.currentTarget.style.display = 'none';
                          e.currentTarget.parentElement.style.background = `linear-gradient(135deg, ${badge.color}22, #0a1628)`;
                        }}
                      />
                      <div style={{
                        position: 'absolute', inset: 0,
                        background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.7) 100%)',
                        pointerEvents: 'none',
                      }} />

                      {/* Date badge */}
                      <div style={{
                        position: 'absolute', top: 14, left: 14,
                        background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(8px)',
                        borderRadius: 14, padding: '8px 16px', textAlign: 'center',
                        minWidth: 52,
                      }}>
                        <div style={{ color: '#fff', fontSize: 22, fontWeight: 800, lineHeight: 1 }}>{fd.date}</div>
                        <div style={{ color: badge.color, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', marginTop: 2 }}>{fd.month}</div>
                      </div>

                      {/* Type badge */}
                      <div style={{
                        position: 'absolute', top: 14, right: 14,
                        display: 'flex', alignItems: 'center', gap: 5,
                        background: `${badge.color}dd`,
                        borderRadius: 8, padding: '5px 12px',
                      }}>
                        <span style={{ fontSize: 13 }}>{badge.icon}</span>
                        <span style={{ color: '#fff', fontWeight: 700, fontSize: 11 }}>{badge.label}</span>
                      </div>

                      {/* Mentor info on image */}
                      {event.mentor?.fullName && (
                        <div style={{
                          position: 'absolute', bottom: 14, left: 14,
                          display: 'flex', alignItems: 'center', gap: 8,
                          background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)',
                          borderRadius: 10, padding: '6px 14px',
                        }}>
                          <div style={{
                            width: 28, height: 28, borderRadius: '50%',
                            background: `linear-gradient(135deg, ${badge.color}, #8b5cf6)`,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            color: '#fff', fontSize: 11, fontWeight: 700, flexShrink: 0,
                          }}>
                            {event.mentor.fullName.split(' ').map(n => n[0]).join('').slice(0, 2)}
                          </div>
                          <div>
                            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 9 }}>Mentor</div>
                            <div style={{ color: '#fff', fontWeight: 600, fontSize: 12 }}>{event.mentor.fullName}</div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Content */}
                    <div style={{ padding: '20px 22px 24px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                      {/* Day & time */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10, fontSize: 13 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 5, color: 'var(--text)' }}>
                          <span style={{ fontSize: 14 }}>📅</span>
                          <span>{fd.day}, {fd.date} {fd.month} {fd.year}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 5, color: 'var(--text)' }}>
                          <span style={{ fontSize: 14 }}>⏰</span>
                          <span>{fd.time} WIB</span>
                        </div>
                      </div>

                      <h5 style={{
                        fontSize: 18, fontWeight: 700, color: 'var(--onsurface)', marginBottom: 10,
                        lineHeight: 1.4, display: '-webkit-box',
                        WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                      }}>
                        {event.title}
                      </h5>

                      <p style={{
                        fontSize: 13, color: 'var(--text)', lineHeight: 1.7, marginBottom: 16, flex: 1,
                        display: '-webkit-box',
                        WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                      }}>
                        {event.description}
                      </p>

                      {/* Location & registration */}
                      <div style={{
                        display: 'flex', gap: 12, marginBottom: 16,
                        padding: '12px 14px',
                        background: 'var(--bg)',
                        borderRadius: 12, border: '1px solid var(--line)',
                      }}>
                        <div style={{ flex: 1, textAlign: 'center' }}>
                          <div style={{ color: badge.color, fontSize: 15, fontWeight: 800 }}>
                            {event.isOnline ? 'Online' : 'Offline'}
                          </div>
                          <div style={{ color: 'var(--text)', fontSize: 11 }}>Lokasi</div>
                        </div>
                        <div style={{ width: 1, background: 'var(--line)' }} />
                        <div style={{ flex: 1, textAlign: 'center' }}>
                          <div style={{ color: '#f59e0b', fontSize: 15, fontWeight: 800 }}>
                            {event.price > 0 ? `Rp ${Number(event.price).toLocaleString()}` : 'Gratis'}
                          </div>
                          <div style={{ color: 'var(--text)', fontSize: 11 }}>Biaya</div>
                        </div>
                        <div style={{ width: 1, background: 'var(--line)' }} />
                        <div style={{ flex: 1, textAlign: 'center' }}>
                          <div style={{ color: '#8b5cf6', fontSize: 15, fontWeight: 800 }}>
                            {maxReg ? `${regCount}/${maxReg}` : '-'}
                          </div>
                          <div style={{ color: 'var(--text)', fontSize: 11 }}>Daftar</div>
                        </div>
                      </div>

                      {/* Registration progress bar */}
                      {maxReg > 0 && (
                        <div style={{ marginBottom: 16 }}>
                          <div style={{
                            width: '100%', height: 4, borderRadius: 4,
                            background: 'var(--line)', overflow: 'hidden',
                          }}>
                            <div style={{
                              width: `${regPct}%`, height: '100%', borderRadius: 4,
                              background: `linear-gradient(90deg, ${badge.color}, #8b5cf6)`,
                              transition: 'width 0.6s ease',
                            }} />
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6, fontSize: 11, color: 'var(--text)' }}>
                            <span>{regPct}% terisi</span>
                            <span>{maxReg - regCount} slot tersisa</span>
                          </div>
                        </div>
                      )}

                      {/* CTA */}
                      <a
                        href={(event.link && /^https:\/\//i.test(event.link)) ? event.link : FE_WEB_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                          width: '100%',
                          background: `linear-gradient(135deg, ${badge.color}, ${badge.color}cc)`,
                          color: '#fff', fontWeight: 700, fontSize: 14,
                          borderRadius: 12, padding: '12px 20px',
                          textDecoration: 'none',
                          transition: 'all 0.3s ease',
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = `0 8px 24px ${badge.color}40`;
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.transform = '';
                          e.currentTarget.style.boxShadow = '';
                        }}
                      >
                        Daftar Sekarang
                        <span style={{ fontSize: 16 }}>→</span>
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {filtered.length === 0 && (
            <div style={{ textAlign: 'center', padding: '80px 20px' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>📅</div>
              <h4 style={{ color: 'var(--onsurface)', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Belum Ada Event</h4>
              <p style={{ color: 'var(--text)', fontSize: 15 }}>
                Belum ada event untuk kategori ini. Coba kategori lain atau nantikan event terbaru kami.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* CTA section — theme-aware */}
      <section style={{ padding: '0 0 80px', background: 'var(--bg)' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{
                background: 'var(--surface)',
                borderRadius: 24, padding: '56px 48px', textAlign: 'center',
                border: '1px solid var(--line)',
                position: 'relative', overflow: 'hidden',
              }}>
                <div style={{
                  position: 'absolute', top: '-30%', right: '-10%', width: 300, height: 300,
                  borderRadius: '50%', background: 'rgba(12,143,134,0.08)', filter: 'blur(50px)',
                }} />
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <span style={{ fontSize: 48, marginBottom: 16, display: 'block' }}>🎤</span>
                  <h3 style={{ color: 'var(--onsurface)', fontSize: 28, fontWeight: 800, marginBottom: 12 }}>
                    Ingin Mengadakan Event?
                  </h3>
                  <p style={{ color: 'var(--text)', fontSize: 16, maxWidth: 520, margin: '0 auto 32px', lineHeight: 1.7 }}>
                    Jadilah mentor atau pembicara di event Tradiora. Hubungi tim kami untuk informasi lebih lanjut.
                  </p>
                  <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Link to="/contact" style={{
                      display: 'inline-flex', alignItems: 'center', gap: 8,
                      background: 'linear-gradient(135deg, var(--primary), #8b5cf6)',
                      color: '#fff', fontWeight: 700, fontSize: 15,
                      borderRadius: 14, padding: '14px 32px', textDecoration: 'none',
                      transition: 'all 0.3s',
                    }}
                      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 30px rgba(139,92,246,0.3)'; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
                    >
                      Hubungi Kami
                    </Link>
                    <Link to="/syarat-ketentuan-mentor" style={{
                      display: 'inline-flex', alignItems: 'center', gap: 8,
                      background: 'var(--bg)', color: 'var(--onsurface)',
                      fontWeight: 600, fontSize: 15, borderRadius: 14,
                      padding: '14px 32px', textDecoration: 'none',
                      border: '1px solid var(--line)',
                      transition: 'all 0.3s',
                    }}
                      onMouseEnter={e => { e.currentTarget.style.background = 'var(--primary-light)'; e.currentTarget.style.borderColor = 'var(--primary)'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = 'var(--bg)'; e.currentTarget.style.borderColor = 'var(--line)'; }}
                    >
                      Syarat Ketentuan Mentor
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Sale01 />

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.08); opacity: 0.7; }
        }
      `}</style>
    </div>
  );
}

export default Event;
